// Home-level AGNI liberty review queue — every resident holding a DoLS
// authorisation that has not been re-tested against *A Reference by the
// Attorney General for Northern Ireland (Deprivation of Liberty)* [2026]
// UKSC 16, plus the home's screening counts.

// FETCH
export const FETCH_LIBERTY_REVIEW = "app/LIBERTY_REVIEW/FETCH_LIBERTY_REVIEW";
export const FETCH_LIBERTY_REVIEW_SUCCESS =
  "app/LIBERTY_REVIEW/FETCH_LIBERTY_REVIEW_SUCCESS";
export const FETCH_LIBERTY_REVIEW_FAILURE =
  "app/LIBERTY_REVIEW/FETCH_LIBERTY_REVIEW_FAILURE";

// RECORD A REVIEW DECISION (keep / lapse / cease / defer to the LA)
export const RECORD_LIBERTY_DECISION =
  "app/LIBERTY_REVIEW/RECORD_LIBERTY_DECISION";
export const RECORD_LIBERTY_DECISION_SUCCESS =
  "app/LIBERTY_REVIEW/RECORD_LIBERTY_DECISION_SUCCESS";
export const RECORD_LIBERTY_DECISION_FAILURE =
  "app/LIBERTY_REVIEW/RECORD_LIBERTY_DECISION_FAILURE";
